import { engineRequest } from './http';

// Ticket totals and breakdowns. Administrators only. Query: `from`, `to`
// (local dates in the account timezone, inclusive, both optional: no dates is
// all time), `site_id`, `category`, `member_id` (the ticket's current
// assignee). 422 `invalid_range` when `to` is before `from`. Note the names:
// the ticket list calls the same dates `created_from` and `created_to`.
export const getReportSummary = params =>
  engineRequest({ path: '/reports/summary', params });

// The weekly file as a Blob. `week_start` is any date (snapped to its Monday,
// default this week), `format` is `xlsx` or `csv`, plus the same site,
// category and member filters. Nothing is emailed: this is a download.
export const getWeeklyReport = (params, format = 'xlsx') =>
  engineRequest({
    path: '/reports/weekly',
    params: { ...params, format },
    responseType: 'blob',
  });
